<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item label="骑行卡名：" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="有效天数：" required prop="effective_days">
          <el-select
            v-model="form.effective_days"
            placeholder="选择有效天数"
            clearable
          >
            <el-option
              v-for="i of effective_days"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否限次：" required prop="is_limit_times">
          <el-radio v-model="form.is_limit_times" :label="is_limit_times0" border>不限次</el-radio>
          <el-radio v-model="form.is_limit_times" :label="is_limit_times1" border>限次</el-radio>
        </el-form-item>
        <el-form-item label="最多可抵扣金额：" required prop="deduction_money">
          <el-input-number
            v-model="form.deduction_money"
            :precision="2"
            :step="0.1"
            :max="20"
          />
        </el-form-item>
        <el-form-item v-show="form.is_limit_times ==1" label="可用次数：" prop="times">
          <el-input-number
            v-model="form.times"
            :min="0"
            :max="100"
            label="可用次数"
          />
        </el-form-item>
        <el-form-item v-show="form.is_limit_times ==0" label="单日最多可用次数：" prop="day_can_ridding_times">
          <el-input-number
              v-model="form.day_can_ridding_times"
              :min="1"
              :max="100"
              label="可用次数"
          />
        </el-form-item>
        <el-form-item label="价格：" required prop="price">
          <el-input-number
            v-model="form.price"
            :precision="2"
            :step="0.1"
            :max="1000"
          />
        </el-form-item>
        <el-form-item label="是否折扣：" required prop="is_discount">
          <el-radio v-model="form.is_discount" :label="is_discount0" border>无折扣</el-radio>
          <el-radio v-model="form.is_discount" :label="is_discount1" border>有折扣</el-radio>
        </el-form-item>

        <el-form-item
          v-show="form.is_discount == 1"
          label="折扣："
          required
          prop="discount"
        >
          <el-input-number
            v-model="form.discount"
            :precision="2"
            :step="0.01"
            :max="1"
          />
        </el-form-item>
        <el-form-item label="区域" prop="areas">
          <el-select
            multiple
            filterable
            clearable
            v-model="form.areas"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否可赠送：" required prop="is_give">
          <el-radio v-model="form.is_give" :label="is_give0" border>不可赠送</el-radio>
          <el-radio v-model="form.is_give" :label="is_give1" border>可赠送</el-radio>
        </el-form-item>
        <el-form-item label="是否启用：" required prop="status">
          <el-radio v-model="form.status" :label="status1" border>启用</el-radio>
          <el-radio v-model="form.status" :label="status0" border>停用</el-radio>
        </el-form-item>
        <!-- <el-form-item label="权限" prop="permissions">
          <el-select
            v-model="form.permissions"
            multiple
            placeholder="选择权限"
            filterable
            clearable
          >
            <el-option
              v-for="i of permissions"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item> -->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
  import LzForm from '@c/LzForm'
  import {storeRidingCard, editRidingCard, updateRidingCard} from '@/api/card-riding'
  import {getAreas} from '@/api/area'
  import FormHelper from '@c/LzForm/FormHelper'

  export default {
    name: 'Form',
    components: {
      LzForm,
    },
    mixins: [
      FormHelper,
    ],
    data() {
      return {
        form: {
          name: '',
          is_limit_times: 0,
          effective_days: '',
          times: 0,
          price: 0,
          discount: 1,
          is_discount: 0,
          deduction_money: 0,
          day_can_ridding_times: 50,
          status: 0,
          areas: [],
          is_give: 0,

        },
        rules: {},
        errors: {},
        areas: [],
        is_limit_times0: 0,
        is_limit_times1: 1,
        status1: 1,
        status0: 0,
        is_give0: 0,
        is_give1: 1,
        is_discount0: 0,
        is_discount1: 1,
        effective_days: [
          {
            value: 3,
            label: '三天',
          },
          {
            value: 7,
            label: '七天',
          },
          {
            value: 15,
            label: '十五天',
          },
          {
            value: 30,
            label: '三十天',
          },
          {
            value: 90,
            label: '一季度',
          },
          {
            value: 180,
            label: '半年',
          },
        ],
        permissions: [],
      }
    },
    methods: {
      async onSubmit() {
        if (this.editMode) {
          await updateRidingCard(this.resourceId, this.form)
        } else {
          await storeRidingCard(this.form)
        }
      },
      async getData() {
        const [
          {data: areas},
        ] = await Promise.all([
          getAreas({all: 1}),
        ])

        this.areas = areas

        if (this.editMode) {
          const {data} = await editRidingCard(this.resourceId)
          data.areas = data.areas.map(i => i.id)
          this.fillForm(data)
        }
      },
    },
  }
</script>
